// extracted by mini-css-extract-plugin
export default {"video":"Video_video__LM3ZV","cover":"Video_cover__+rG6b"};